// Depends
import { subGroup, route, professionalMeta } from '@/helpers/routes'
import Index from './index/index'
import Form from './form/form'

const routes = [
  route('index', '/index', Index, professionalMeta('Lista de Especialidades')),
  route('create', '/create', Form, professionalMeta('Adicionar Especialidade')),
  route('edit', '/:id/edit', Form, professionalMeta('Editar Especialidade'))
]

export default subGroup('/specialities', routes)



// WEBPACK FOOTER //
// ./src/app/professional/record/specialities/routes.js